// | Controlling Bootstrap modals from Specular widgets.
import * as $runtime from "../runtime.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Specular$dBootstrap$dModal from "../Specular.Bootstrap.Modal/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const $ModalAction = tag => ({tag});
const Show = /* #__PURE__ */ $ModalAction("Show");
const Hide = /* #__PURE__ */ $ModalAction("Hide");
const controlModal = node => event => Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder)(v => {
  if (v.tag === "Show") {
    const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Specular$dBootstrap$dModal.showModalBs5(node));
    return () => {
      const fiber = $0();
      fiber.run();
    };
  }
  if (v.tag === "Hide") {
    const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Specular$dBootstrap$dModal.hideModalBs5(node));
    return () => {
      const fiber = $0();
      fiber.run();
    };
  }
  $runtime.fail();
})(event);
export {$ModalAction, Hide, Show, controlModal};
